import { BusinessUnitEmailContactService } from './business-unit-email-contact.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BUSINESS_UNIT_EMAIL_CONTACT_TYPE, BusinessUnitEmailContact } from 'assets-model';
import { Observable } from 'rxjs';



@Injectable({ providedIn: 'root' })
export abstract class BusinessUnitEmailContactResolverBase implements Resolve<BusinessUnitEmailContact> {

  constructor(protected service: BusinessUnitEmailContactService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<BusinessUnitEmailContact> {
    const key: number = BUSINESS_UNIT_EMAIL_CONTACT_TYPE.entityDecorator.toKeyObjectFromRouteParams(route.params);
    return this.service.get(key);
  }
}



